/// HOOKS ///
import { useAppDispatch } from "api/hooks/apiHook";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
/// ACTIONS ///
import { filterWOs } from "api/actions/wo/wo";
import { setBreadcrumbs } from "api/actions/ui/set";
/// TYPES ///
import { IGetOrderArgs } from "api/types/order/order";
/// MUI COMPONENTS ///
import Box from "@mui/material/Box";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Grid from "@mui/material/Grid";
import { TextField } from "@mui/material";
/// PAGE COMPONENTS ///
import BaseButton from "components/universal/button/base";
import PageTitle from "components/universal/page/title";
/// FM ///
import { motion } from "framer-motion";
/// ICONS ///
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { faEraser } from "@fortawesome/free-solid-svg-icons";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
/// STYLES ///
import { content_container_style } from "styles/universal/page";
import { header_style } from "styles/universal/section_header";
/// MOTION ///
import { m_init_page } from "motion/page";
import { m_anim_page } from "motion/page";
import { m_exit_page } from "motion/page";
import { page_trans } from "motion/page";
/// URLS ///
import { wo_url } from "components/navigation/endpoints";
/// BREADCRUMBS ///
import { wo_list } from "values/breadcrumbs/wo";
import { wo_filter } from "values/breadcrumbs/wo";

export default function FilterWOs() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [filter, setFilter] = useState<IGetOrderArgs>({});

  useEffect(() => {
    dispatch(setBreadcrumbs([
      wo_list,
      wo_filter
    ]));
  }, [dispatch]);


  const clear = () => {
    setFilter({});
  }
  const applyFilter = () => {
    dispatch(filterWOs(filter));
    navigate(`/${wo_url}`);
  }

  const keyDown = (e: any) => {
    if (e.key === "Enter") {
      e.preventDefault();
      applyFilter();
    }
  }

  return (
    <motion.div initial={m_init_page} exit={m_exit_page} animate={m_anim_page} transition={page_trans} style={content_container_style} onKeyDown={keyDown}>
      <Grid container>
        <PageTitle title="Filter Work Orders" endProps={
          <Box>
            <BaseButton clickEvent={() => navigate(`/${wo_url}`)} text="Cancel" icon={faTimes} />
            <BaseButton clickEvent={clear} text="Clear" icon={faEraser} />
            <BaseButton clickEvent={() => applyFilter()} text="Apply" icon={faFilter} />
          </Box>
        } />
        <Grid item xs={12}>
          <Box style={header_style}></Box>
        </Grid>
        <Grid item xs={12} sx={{ paddingTop: "20px" }}>
          <Box display="flex" flexDirection="column" alignItems="flex-start" sx={{ gap: "10px" }}>
            <TextField
              onChange={e => setFilter({ ...filter, order_name: e.target.value })}
              value={filter.order_name}
              label="Quote Name" />
            <TextField
              onChange={e => setFilter({ ...filter, customer_name: e.target.value })}
              value={filter.customer_name}
              label="Account Last Name" />
            <DatePicker
              slotProps={{ textField: { size: 'small', InputLabelProps: { shrink: true }, fullWidth: true } }}
              label="Start Date"
              onChange={e => setFilter({ ...filter, start_date: e.toUTC().toISO() })} />
            <DatePicker
              slotProps={{ textField: { size: 'small', InputLabelProps: { shrink: true }, fullWidth: true } }}
              label="End Date"
              onChange={e => setFilter({ ...filter, end_date: e.toUTC().toISO() })} />
          </Box>
        </Grid>
      </Grid>
    </motion.div>
  )
}
